/**
 * @file index.tsx
 *
 * @fileoverview Contains Sorting filter util functions.
 */
import { IntlShape } from 'react-intl';

export type SortingFilterOption = {
  /**
   * The filter option name visible to the user.
   */
  name: string;
  /**
   * The filter option code used in the query and request (e.g., 'publish_date_desc').
   */
  code: string;
  /**
   * The Drupal field machine name to sort by (e.g., 'field_job_publishing_date').
   */
  field: string;
  /**
   * The sort direction, either 'asc' for ascending or 'desc' for descending.
   */
  value: string;
};

/**
 * Returns a list of available sorting filter options used for displaying
 * search or listing results (e.g., by relevancy or recency).
 *
 * If an `intl` object is provided, the option names will be localized
 * using `intl.formatMessage`. Otherwise, default English labels are used.
 *
 * @param intl - Optional `IntlShape` instance for localization. If null, default labels are returned.
 * @returns An array of sorting filter option objects.
 */
export function getSortingFilterOptions(
  intl: IntlShape | null = null,
): SortingFilterOption[] {
  return [
    {
      name: intl
        ? intl.formatMessage({
            id: 'sorting_filter_relevancy',
            defaultMessage: 'Relevancy',
          })
        : 'Relevancy',
      code: 'relevancy',
      field: 'search_api_relevance',
      value: 'desc',
    },
    {
      name: intl
        ? intl.formatMessage({
            id: 'sorting_filter_recency',
            defaultMessage: 'Recency',
          })
        : 'Recency',
      code: 'publish_date_desc',
      field: 'field_job_publishing_date',
      value: 'desc',
    },
  ];
}
